import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=f777b92a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f777b92a')) {
      api.createRecord('f777b92a', component.options)
    } else {
      api.reload('f777b92a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=f777b92a&", function () {
      api.rerender('f777b92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zxp6WqS1Nph1/JS/comp/ErrorMessage.vue"
export default component.exports